import { useEffect } from "react";

import Context from "shared/util/Context";

import OneTrust from "shared/util/oneTrust";

const GOOGLE_ADWORDS_SDK_URL = "https://www.googletagmanager.com/gtag/js?id=AW-829392633";

const initGoogleAdwords = () => {
	window.dataLayer = window.dataLayer || [];
	window.gtag = (...args) => { window.dataLayer.push(args); };
	window.gtag("js", new Date());

	window.gtag("config", "AW-829392633");
	window.gtag("config", "DC-8236637");
};

function useGoogleAdwords({ location }) {
	useEffect(() => {
		initGoogleAdwords();

		if (!Context.has("BLOCK_PERSONALIZED_MARKETING")) {
			OneTrust.loadScript(GOOGLE_ADWORDS_SDK_URL, OneTrust.CATEGORY.ADVERTISING);
		}
	}, []);

	const currentPath = location.pathname;
	useEffect(() => {
		if (!window.gtag) {
			return;
		}

		window.gtag("config", "AW-829392633", { page_path: currentPath });
		window.gtag("config", "DC-8236637", { page_path: currentPath });
	}, [currentPath]);
}

export default useGoogleAdwords;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useGoogleAdwords.js